import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import { toast } from "react-toastify";
import { createEnquiry } from "../../api/apiUrlConst";

interface EnquiryFormData {
  name: string;
  phoneNumber: string;
  email: string;
  courseCategory: string;
  courseName: string;
  message?: string;

  gender?: string;
  dob?: string;
  highEdu?: string;
  secHighEdu?: string;
  totalExperience?: number;
  currentSkillExp?: string;
  currentEmployer?: string;
  currentDesignation?: string;
  previousEmployer?: string;
  previousDesignation?: string;
  ctc?: string;
  expectedCTC?: string;
  country?: string;
  state?: string;
  city?: string;
  postalPinCode?: string;
}

const EnquiryFormPage: React.FC = () => {
  const [step, setStep] = useState<number>(1);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const [formData, setFormData] = useState<EnquiryFormData>({
    name: "",
    phoneNumber: "",
    email: "",
    courseCategory: "",
    courseName: "",
    message: "",
    gender: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    if (name === "courseCategory") {
      setFormData((prev) => ({
        ...prev,
        courseCategory: value,
        courseName: "", // reset course name
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const validateStep1 = () => {
    // if (
    //   !formData.name ||
    //   !formData.phoneNumber ||
    //   !formData.email ||
    //   !formData.courseCategory ||
    //   !formData.courseName
    // ) {
    //   toast.warning("Please fill all mandatory fields.");
    //   return false;
    // }
    return true;
  };

  const handleInitialSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateStep1()) return;

    await submitToServer();
  };

  const submitToServer = async () => {
    try {
      setLoading(true);

      await createEnquiry({
        ...formData,
      });

      toast.success("Enquiry submitted successfully!");

      // Reset
      setFormData({
        name: "",
        phoneNumber: "",
        email: "",
        courseCategory: "",
        courseName: "",
        message: "",
      });

      setStep(1);
      setShowModal(false);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || "Something went wrong."
      );
    } finally {
      setLoading(false);
    }
  };


  const courseOptions: { [key: string]: string[] } = {
   "AI ML": [
      "Artificial Intelligence",
      "Data Science",
      "Machine Learning",
    ],
    "Programming": [

      "Python Programming",
      "C++",
      "C#.Net",
      "Java",
    ],
    "CAD Automation": [
      "C++ & Creo Toolkit",
      "C++ & CATIA CAA",
      "",
      "C#.Net & Solidworks API",
      "C#.Net & Nx Customization",
      "C#.Net & Autodesk Inventor API",
      "C#.Net & AutoCAD API",
      "C#.Net & Solid Edge API",
      "C#.Net & Revit API",
      "",
      "Python & CATIA CAA",
      "Python & Nx Customization",
      "",
      "NX Customization",
      "SolidWorks API",
      "CATIA CAA",
      "Creo Toolkit",
      "Revit API",
      "AutoCAD API",
      "Solid Edge API",
      "Autodesk Inventor API",
    ],
    "PLM Automation": [
      "Java & Windchill",
      "C++ & Team center",
      "Windchill",
      "Teamcenter",
    ],
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: "92.1vh",
        background: "linear-gradient(135deg, #667eea, #764ba2)",
        padding: "40px 15px",
      }}
    >
      <Card
        className="shadow-lg border-0"
        style={{
          maxWidth: "850px",
          width: "100%",
          borderRadius: "20px",
          backdropFilter: "blur(10px)",
          background: "rgba(255,255,255,0.95)",
        }}
      >
        <CardBody className="p-5">

          {/* Header */}
          <div className="text-center mb-4">
            <h2 style={{ fontWeight: 700, color: "#333" }}>
              GET IN TOUCH
            </h2>
            <p style={{ color: "#777", marginBottom: 0 }}>
             Let our executive call you back with complete information
            </p>
          </div>

          <Form onSubmit={handleInitialSubmit}>
            <Row>
              <Col md={4}>
                <FormGroup>
                  <Input
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className=" px-3 py-2 shadow-sm"
                    placeholder="Full Name"
                  />
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className=" px-3 py-2 shadow-sm"
                    placeholder="Email"
                  />
                </FormGroup>
              </Col>
               <Col md={4}>
                <FormGroup>
                  {/* <Label className="fw-semibold">Phone Number *</Label> */}
                  <Input
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    required
                    className=" px-3 py-2 shadow-sm"
                    placeholder="Phone No"
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
             

              {/* <Col md={6}>
                <FormGroup>
                  <Label className="fw-semibold">Gender *</Label>
                  <Input
                    type="select"
                    name="gender"
                    value={formData.gender || ""}
                    onChange={handleChange}
                    required
                    className="rounded-pill px-3 py-2 shadow-sm"
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </Input>
                </FormGroup>
              </Col> */}
            </Row>
            {/* <Row>
              <Col md={6}>
                <FormGroup>
                  <Label className="fw-semibold">Course Category *</Label>
                  <Input
                    type="select"
                    name="courseCategory"
                    value={formData.courseCategory || ""}
                    onChange={handleChange}
                    required
                    className="rounded-pill px-3 py-2 shadow-sm"
                  >
                    <option value="">Select Category</option>
                    <option value="AI ML">AI ML</option>
                    <option value="Programming">Programming</option>
                    <option value="CAD Automation">CAD Automation</option>
                    <option value="PLM Automation">PLM Automation</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label className="fw-semibold">Course Name *</Label>
                  <Input
                    type="select"
                    name="courseName"
                    value={formData.courseName || ""}
                    onChange={handleChange}
                    required
                    disabled={!formData.courseCategory}
                    className="rounded-pill px-3 py-2 shadow-sm"
                  >
                    <option value="">Select Course</option>
                    {formData.courseCategory &&
                      courseOptions[formData.courseCategory]?.map((course, index) => (
                        <option key={index} value={course}>
                          {course}
                        </option>
                      ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row> */}

            <FormGroup>
              {/* <Label className="fw-semibold">Message <small className="text-muted">(if any)</small> </Label> */}
              <Input
                type="textarea"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className=" shadow-sm"
                rows={4}
                placeholder="Write your message..."
              />
            </FormGroup>

            <Button
              type="submit"
              disabled={loading}
              className="w-100 mt-3"
              style={{
                background: "linear-gradient(90deg, #667eea, #764ba2)",
                border: "none",
                padding: "12px",
                fontWeight: 600,
                fontSize: "16px",
                transition: "0.3s",
              }}
            >
              {loading ? "Submitting..." : "Submit Enquiry"}
            </Button>

          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default EnquiryFormPage;